<template>
  <div>
    <div v-if="!horas.length" class="text-center caption my-6">
      Sin datos para mostrar.
    </div>

    <v-simple-table v-else class="custom-stripped-color no-seleccionable hora-por-hora-table">
      <template v-slot:default>
        <thead>
          <!-- Fila 1: grupos -->
          <tr class="text-center">
            <th class="font-weight-bold pa-3 custom-background-color max-width-th" rowspan="3">
              Hora
            </th>

            <th v-for="cell in topRowCells" :key="cell.key" class="font-weight-bold pa-3" :class="cell.className"
              :colspan="cell.colspan">
              {{ cell.title }}
            </th>

            <th class="font-weight-bold pa-3 custom-background-color" rowspan="3" style="min-width:160px;">
              Tiempo De Paro<br>(HH:MM:SS)
            </th>
            <th class="font-weight-bold pa-3 custom-background-color" rowspan="3">OEE</th>
            <!-- <th class="white--text font-weight-bold pa-3 grey darken-2" rowspan="3">Acciones</th> -->
          </tr>

          <!-- Fila 2: subgrupos -->
          <tr class="text-center">
            <th v-for="cell in secondRowCells" :key="cell.key" class="font-weight-bold pa-2" :class="cell.className"
              :colspan="cell.colspan">
              {{ cell.label }}
            </th>
          </tr>

          <!-- Fila 3: nombres de cavidad (lista plana, sin <template v-for>) -->
          <!-- <tr class="text-center counter-font-default-size">
            <th v-for="cell in thirdRowCells" :key="cell.key" class="pa-2 text-center">
              {{ cell.text }}
            </th>
          </tr> -->
          <tr class="text-center counter-font-default-size">
            <th v-for="cell in thirdRowCells" :key="cell.key" class="pa-2 text-center" :class="cell.className">
              {{ cell.text }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(h, idx) in horas" :key="'h-' + idx" class="text-center">
            <!-- Hora -->
            <td class="pa-3 font-weight-medium">
              <div>{{ h.desdeHora || h.DesdeHora }} - {{ h.hastaHora || h.HastaHora }}</div>
              <div v-if="h.fecha || h.Fecha" class="caption">{{ h.fecha || h.Fecha }}</div>
            </td>

            <!-- <td v-for="col in bodyCols" :key="'b-' + idx + '-' + col.key" class="pa-3">
              {{ cell(h, col.cavId, col.field) }}
            </td> -->
            <td v-for="col in bodyCols" :key="'b-' + idx + '-' + col.key" :class="['pa-3', col.className]">
              {{ cell(h, col.cavId, col.field) }}
            </td>

            <td class="pa-3 tiempo-paro-cell">
              <ul class="ma-0 pa-0" style="list-style:none;">
                <li><strong>Programados:</strong> <br> {{ fmtSegundos(getParos(h).prog) }}</li>
                <br>
                <li><strong>No programados:</strong> <br> {{ fmtSegundos(getParos(h).noProg) }}</li>
              </ul>
            </td>

            <td class="pa-3">{{ formatOee(rowOee(h)) }}</td>

            <!-- <td class="pa-2">
              <v-icon small @click="emitDetalleFromHour(h)">mdi-eye</v-icon>
            </td> -->
          </tr>
        </tbody>


        <tfoot>
          <tr class="text-center">
            <td class="font-weight-bold pa-3 custom-background-color white--text">Total</td>

            <!-- Totales alineados con bodyCols -->
            <!-- <td v-for="col in bodyCols" :key="'t-' + col.key" class="pa-3 font-weight-bold">
              {{ totals.perCav[col.cavId][col.field] }}
            </td> -->
            <td v-for="col in bodyCols" :key="'t-' + col.key" :class="['pa-3', 'font-weight-bold', col.className]">
              <!-- {{ totals.perCav[col.cavId][col.field] }} -->
              {{ totalCell(col) }}
            </td>


            <!-- <td class="pa-3 font-weight-bold">{{ totals.tmMin }}</td> -->
            <td class="pa-3 font-weight-bold">
              <v-tooltip top color="black">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <!-- {{ fmtSegundos(totals.tmSeg || 0) }} -->
                    {{ fmtSegundos((totals.segParoProg || 0) + (totals.segParoNoProg || 0)) }}
                  </span>
                </template>
                <span class="white--text">
                  <!-- Inactividad: {{ fmtSegundos(totals.segInactividad || 0) }}  -->
                  <!-- <br> -->
                  Paro prog.:  {{ fmtSegundos(totals.segParoProg || 0) }} 
                  <br>
                  Paro no prog.: {{ fmtSegundos(totals.segParoNoProg || 0) }}
                </span>
              </v-tooltip>
            </td>
            <td class="pa-3 font-weight-bold">{{ formatOee(totals.oee) }}</td>
            <!-- <td></td> -->
          </tr>
        </tfoot>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: 'HoraPorHoraTabla',
  props: { 
    value: { type: Object, required: true }, // { resumen, horas | Horas }
    agruparPor: { type: String, default: 'cavidades' } // 'cavidades' | 'articulos'
  }, 
  data() {
    return {
      cavList: [],
      rows: [],
      // totals: { perCav: {}, tmMin: 0, oee: 0 },
      totals: { perCav: {}, tmSeg: 0, segParoNoProg: 0, segParoProg: 0, /*segInactividad: 0,*/ oee: 0 },
      cavArticuloMap: {},
      headerGroups: [
        {
          key: 'est',
          title: 'Esperado',
          headerClass: 'background-color-estandar',
          subHeaderClass: 'background-color-estandar_row',
          fields: [
            { key: 'estHora', label: 'Hora' },
            { key: 'estAcum', label: 'Acumulado' }
          ]
        },
        {
          key: 'real',
          title: 'Real',
          headerClass: 'background-color-real',
          subHeaderClass: 'background-color-real_row',
          fields: [
            { key: 'realHora', label: 'Hora' },
            { key: 'realAcum', label: 'Acumulado' }
          ]
        },
        {
          key: 'dif',
          title: 'Diferencia',
          headerClass: 'background-color-diferencia',
          subHeaderClass: 'background-color-diferencia_row',
          fields: [
            { key: 'diffHora', label: 'Hora' },
            { key: 'diffAcum', label: 'Acumulado' }
          ]
        },
        {
          key: 'nok',
          title: 'Piezas NO OK',
          headerClass: 'custom-background-color',
          subHeaderClass: 'custom-background-color', // no se usa visualmente
          fields: [
            { key: 'noOk', label: '' } // solo una columna por cavidad
          ]
        }
      ]
    }
  },
  computed: {
    horas() {
      const v = this.value || {}
      const arr = Array.isArray(v.horas) ? v.horas : (Array.isArray(v.Horas) ? v.Horas : [])
      return arr || []
    },
    cavCount() { return this.cavList.length },

    // Encabezado fila 1 (títulos de grupo)
    topRowCells() {
      const cells = []
      const n = this.cavCount || 0
      for (let i = 0; i < this.headerGroups.length; i++) {
        const g = this.headerGroups[i]
        cells.push({
          key: 'top-' + g.key,
          title: g.title,
          colspan: g.fields.length * n,
          className: g.headerClass
        })
      }
      return cells
    },

    secondRowCells() {
      const cells = []
      const n = this.cavCount || 0

      for (let i = 0; i < this.headerGroups.length; i++) {
        const g = this.headerGroups[i]
        for (let j = 0; j < g.fields.length; j++) {
          const f = g.fields[j]
          cells.push({
            key: 'sub-' + g.key + '-' + f.key,
            label: f.label,
            // colspan: n,
            colspan: Math.max(1, n),
            // ⬇️ agrega white--text para que el texto sea del mismo color (blanco) que los títulos
            className: g.headerClass
          })
        }
      }
      return cells
    },

    thirdRowCells() {
      const cells = []
      for (let i = 0; i < this.headerGroups.length; i++) {
        const g = this.headerGroups[i]
        for (let j = 0; j < g.fields.length; j++) {
          for (let k = 0; k < this.cavList.length; k++) {
            const c = this.cavList[k]
            cells.push({
              key: 'cav-' + g.key + '-' + g.fields[j].key + '-' + c.id,
              // text: c.short,
              text: c.name,
              className: g.headerClass + ' white--text' // <- mismo color que el título
            })
          }
        }
      }
      return cells
    },

    bodyCols() {
      const cols = []
      const classPerGroup = {
        est: 'background-color-estandar_row',
        real: 'background-color-real_row',
        dif: 'background-color-diferencia_row',
        nok: '' // si quieres también puedes crear una clase para NO OK
      }
      for (let i = 0; i < this.headerGroups.length; i++) {
        const g = this.headerGroups[i]
        for (let j = 0; j < g.fields.length; j++) {
          const f = g.fields[j]
          for (let k = 0; k < this.cavList.length; k++) {
            const c = this.cavList[k]
            cols.push({
              key: `col-${g.key}-${f.key}-${c.id}`,
              cavId: c.id,
              field: f.key,
              className: classPerGroup[g.key] || ''
            })
          }
        }
      }
      return cols
    },
    effectiveCavList() {
      return this.cavList.length ? this.cavList : [{ id: '__default__', name: 'Única', short: 'Ún' }]
    },
  },
  watch: {
    value: { immediate: true, deep: true, handler() { this.rebuild() } },
    agruparPor(val, oldVal) {
      if (val !== oldVal) this.rebuild();
    }
  },
  methods: {
    emitDetalleFromHour(h) {
      this.$emit('ver-detalle', { row: h })
    },

    cell(h, cavId, field) {
      const cavs = this.getProp(h, ['cavidades', 'Cavidades']) || [];
      const modo = (this.agruparPor || '').toLowerCase();

      // === MODO ARTÍCULOS ===
      if ((this.agruparPor || '').toLowerCase() === 'articulos') {
        const cavs = this.getProp(h, ['cavidades','Cavidades']) || [];
        const artId = cavId; // aquí cavId es el idArticulo

        let estHora = 0, estAcum = 0, realHora = 0, realAcum = 0, noOk = 0;

        for (const c of cavs) {
          const cavToken = this.getProp(c, ['idTokenExtra', 'IdTokenExtra']);
          let artCav = null;

          const arts = Array.isArray(c?.articulos) ? c.articulos : [];
          if (arts.length) {
            const found = arts.find(a => (a?.idArticulo ?? a?.IdArticulo ?? a?.id) != null);
            if (found) {
              artCav = found.idArticulo ?? found.IdArticulo ?? found.id;
            }
          }

          if (artCav == null) {
            const direct = (
              c?.idArticulo ?? c?.IdArticulo ??
              c?.articulo?.idArticulo ?? c?.Articulo?.IdArticulo ??
              c?.articulo?.id ?? c?.Articulo?.Id
            );
            if (direct != null) artCav = direct;
          }

          if (artCav == null && cavToken != null && this.cavArticuloMap) {
            artCav = this.cavArticuloMap[cavToken];
          }

          if (artCav !== artId) continue;

          const n = (keys) => this.num(this.getProp(c, keys));
          estHora  += n(['piezasTeoricasHora',      'PiezasTeoricasHora']);
          estAcum  += n(['piezasTeoricasAcumulado', 'PiezasTeoricasAcumulado']);
          realHora += n(['piezasOkHora',            'PiezasOkHora']);
          realAcum += n(['piezasOkAcumulado',       'PiezasOkAcumulado']);
          noOk     += n(['piezasNoOkHora',          'PiezasNoOkHora']);
        }

        if (field === 'estHora')  return estHora;
        if (field === 'estAcum')  return estAcum;
        if (field === 'realHora') return realHora;
        if (field === 'realAcum') return realAcum;
        if (field === 'diffHora') return realHora - estHora;
        if (field === 'diffAcum') return realAcum - estAcum;
        if (field === 'noOk')     return noOk;
        return 0;
      }


      // === MODO CAVIDADES: comportamiento existente (por cavidad) ===
      const c = cavs.find(cv => this.getProp(cv, ['idTokenExtra', 'IdTokenExtra']) === cavId);
      if (!c) return 0;

      const n = (keys) => this.num(this.getProp(c, keys));
      if (field === 'diffHora') return n(['piezasOkHora','PiezasOkHora']) - n(['piezasTeoricasHora','PiezasTeoricasHora']);
      if (field === 'diffAcum') return n(['piezasOkAcumulado','PiezasOkAcumulado']) - n(['piezasTeoricasAcumulado','PiezasTeoricasAcumulado']);

      const map = {
        estHora:  ['piezasTeoricasHora',      'PiezasTeoricasHora'],
        estAcum:  ['piezasTeoricasAcumulado', 'PiezasTeoricasAcumulado'],
        realHora: ['piezasOkHora',            'PiezasOkHora'],
        realAcum: ['piezasOkAcumulado',       'PiezasOkAcumulado'],
        noOk:     ['piezasNoOkHora',          'PiezasNoOkHora']
      };
      return n(map[field] || []);
    },

    tmMin(h) {
      const cavs = this.getProp(h, ['cavidades', 'Cavidades']) || []
      return cavs.reduce((acc, c) => {
        return acc + this.num(
          this.getProp(c, [
            'tiempoMuertoMinutos', 'TiempoMuertoMinutos',
            'minutosTiempoParo', 'MinutosTiempoParo',
            'minutosParo', 'MinutosParo'
          ])
        )
      }, 0)
    },

    // rowOee(h) {
    //   const cavs = this.getProp(h, ['cavidades', 'Cavidades']) || []
    //   const est = cavs.reduce((a, c) => a + this.num(this.getProp(c, ['piezasTeoricasHora', 'PiezasTeoricasHora'])), 0)
    //   const real = cavs.reduce((a, c) => a + this.num(this.getProp(c, ['piezasOkHora', 'PiezasOkHora'])), 0)
    //   return est > 0 ? (real / est) * 100 : 0
    // },
    rowOee(h) {
      const cavs = h.cavidades || h.Cavidades || [];
      const teorAcum = cavs.reduce((a, c) =>
        a + Number(c.piezasTeoricasAcumulado ?? c.PiezasTeoricasAcumulado ?? 0), 0);

      const oeeAcum = Number(
        h?.resumen?.acumulado?.oee ??
        h?.Resumen?.Acumulado?.Oee ?? 0
      );

      // Muestra el OEE acumulado solo si ya hay teóricas acumuladas
      return teorAcum > 0 ? oeeAcum : 0;
    },

    // ===== Helpers =====
    getProp(obj, names) {
      for (let i = 0; i < names.length; i++) {
        const k = names[i]
        if (obj && Object.prototype.hasOwnProperty.call(obj, k)) return obj[k]
      }
      return undefined
    },
    num(v) { const n = Number(v); return isNaN(n) ? 0 : n },
    abrev(txt, def) {
      if (!txt || typeof txt !== 'string') return def || ''
      const t = txt.trim()
      if (/^iz?q/i.test(t)) return 'Izq'
      if (/^der/i.test(t)) return 'Der'
      return t.length <= 3 ? t : t.slice(0, 3)
    },

    buildCavList() {
      const modo = (this.agruparPor || '').toLowerCase();

      // === AGRUPAR POR ARTÍCULOS ===
      if (modo === 'articulos') {
        const map = {};
        for (const H of this.horas) {
          const cavs = this.getProp(H, ['cavidades', 'Cavidades']) || [];
          for (const c of cavs) {
            const arts = Array.isArray(c?.articulos) ? c.articulos : [];
            for (const a of arts) {
              const id = a?.idArticulo ?? a?.id;
              if (id == null) continue;
              const nombre =
                (a?.nombre ?? (this._nombreArticulo ? this._nombreArticulo(id) : null)) ||
                ('Artículo ' + id);
              if (!map[id]) {
                map[id] = { id, name: nombre, short: this.abrev(nombre, 'A' + id) };
              }
            }
          }
        }
        const list = Object.values(map).sort((a, b) => String(a.name).localeCompare(String(b.name)));
        return list.length ? list : [{ id: '__art__', name: 'Artículo', short: 'Art' }];
      }

      // === AGRUPAR POR CAVIDADES (comportamiento original) ===
      const map = {};
      for (const H of this.horas) {
        const cavs = this.getProp(H, ['cavidades', 'Cavidades']) || [];
        for (const c of cavs) {
          const id = this.getProp(c, ['idTokenExtra', 'IdTokenExtra']);
          if (id == null) continue;
          const nombre = this.getProp(c, ['cavidad', 'Cavidad']) || ('Cavidad ' + id);
          map[id] = map[id] || { id, name: nombre, short: this.abrev(nombre, 'C' + id) };
        }
      }
      const list = Object.values(map).sort((a, b) => String(a.id).localeCompare(String(b.id)));
      return list.length ? list : [{ id: '__default__', name: 'Única', short: 'Ún' }];
    },

    buildRows() {
      const rows = []
      for (let i = 0; i < this.horas.length; i++) {
        const H = this.horas[i]
        const desde = this.getProp(H, ['desdeHora', 'DesdeHora']) || ''
        const hasta = this.getProp(H, ['hastaHora', 'HastaHora']) || ''
        const fecha = this.getProp(H, ['fecha', 'Fecha']) || ''
        const cavs = this.getProp(H, ['cavidades', 'Cavidades']) || []

        // Inicializar contenedor por cavidad
        const perCav = {}
        for (let k = 0; k < this.cavList.length; k++) {
          perCav[this.cavList[k].id] = {
            estHora: 0, estAcum: 0,
            realHora: 0, realAcum: 0,
            diffHora: 0, diffAcum: 0,
            noOk: 0
          }
        }

        let sumEstHora = 0
        let sumRealHora = 0
        let sumTm = 0

        for (let j = 0; j < cavs.length; j++) {
          const c = cavs[j];
          const idCav = this.getProp(c, ['idTokenExtra', 'IdTokenExtra']);

          const estHora = this.num(this.getProp(c, ['piezasTeoricasHora', 'PiezasTeoricasHora']));
          const estAcum = this.num(this.getProp(c, ['piezasTeoricasAcumulado', 'PiezasTeoricasAcumulado']));

          const realHora = this.num(this.getProp(c, ['piezasOkHora', 'PiezasOkHora']));
          const realAcum = this.num(this.getProp(c, ['piezasOkAcumulado', 'PiezasOkAcumulado']));

          const noOk = this.num(this.getProp(c, ['piezasNoOkHora', 'PiezasNoOkHora']));

          const tmMin = this.num(
            this.getProp(c, [
              'tiempoMuertoMinutos', 'TiempoMuertoMinutos',
              'minutosTiempoParo', 'MinutosTiempoParo',
              'minutosParo', 'MinutosParo'
            ])
          );

          const modo = (this.agruparPor || '').toLowerCase();
          if (modo === 'articulos') {
            const arts = Array.isArray(c?.articulos) ? c.articulos : [];
            let artId = null;

            if (arts.length) {
              const found = arts.find(a => (a?.idArticulo ?? a?.IdArticulo ?? a?.id) != null);
              if (found) artId = found.idArticulo ?? found.IdArticulo ?? found.id;
            }

            if (artId == null) {
              const direct = (
                c?.idArticulo ?? c?.IdArticulo ??
                c?.articulo?.idArticulo ?? c?.Articulo?.IdArticulo ??
                c?.articulo?.id ?? c?.Articulo?.Id
              );
              if (direct != null) artId = direct;
            }

            if (artId == null && idCav != null && this.cavArticuloMap) {
              artId = this.cavArticuloMap[idCav];
            }

            if (artId != null && perCav[artId]) {
              perCav[artId].estHora  += estHora;
              perCav[artId].estAcum  += estAcum;
              perCav[artId].realHora += realHora;
              perCav[artId].realAcum += realAcum;
              perCav[artId].diffHora += (realHora - estHora);
              perCav[artId].diffAcum += (realAcum - estAcum);
              perCav[artId].noOk     += noOk;
            }
          } else {
            // CAVIDADES (comportamiento original)
            if (perCav[idCav]) {
              perCav[idCav].estHora = estHora;
              perCav[idCav].estAcum = estAcum;
              perCav[idCav].realHora = realHora;
              perCav[idCav].realAcum = realAcum;
              perCav[idCav].diffHora = realHora - estHora;
              perCav[idCav].diffAcum = realAcum - estAcum;
              perCav[idCav].noOk = noOk;
            }
          }

          // Totales por hora (sin cambios)
          sumEstHora += estHora;
          sumRealHora += realHora;
          sumTm += tmMin;
        }

        const oee = sumEstHora > 0 ? (sumRealHora / sumEstHora) * 100 : 0

        rows.push({
          horaRango: (desde && hasta) ? (desde + ' - ' + hasta) : '',
          fecha: fecha || '',
          perCav,
          tmMin: sumTm,
          oee
        })
      }
      return rows
    },

    buildCavArticuloMap() {
      const map = {};
      for (const H of this.horas) {
        const cavs = this.getProp(H, ['cavidades', 'Cavidades']) || [];
        for (const c of cavs) {
          const cavId = this.getProp(c, ['idTokenExtra', 'IdTokenExtra']);
          if (cavId == null) continue;

          const arts = Array.isArray(c?.articulos) ? c.articulos : [];
          for (const a of arts) {
            const artId = a?.idArticulo ?? a?.IdArticulo ?? a?.id;
            if (artId == null) continue;

            if (map[cavId] == null) {
              map[cavId] = artId; // ligamos esa cavidad a ese artículo
            }
          }
        }
      }
      return map;
    },
    buildTotals(rows) {
      const perCav = {}
      for (let i = 0; i < this.cavList.length; i++) {
        const id = this.cavList[i].id
        perCav[id] = { estHora: 0, estAcum: 0, realHora: 0, realAcum: 0, diffHora: 0, diffAcum: 0, noOk: 0 }
      }

      // Piezas (igual que antes)
      for (let r = 0; r < rows.length; r++) {
        const row = rows[r]
        for (let i = 0; i < this.cavList.length; i++) {
          const id = this.cavList[i].id
          const c = row.perCav[id] || {}
          perCav[id].estHora += this.num(c.estHora)
          perCav[id].realHora += this.num(c.realHora)
          perCav[id].diffHora += this.num(c.diffHora)
          perCav[id].noOk    += this.num(c.noOk)
          perCav[id].estAcum  = this.num(c.estAcum)  || perCav[id].estAcum
          perCav[id].realAcum = this.num(c.realAcum) || perCav[id].realAcum
          perCav[id].diffAcum = this.num(c.diffAcum) || perCav[id].diffAcum
        }
      }

      // Segundos de tiempo muerto desde this.horas
      let segParoNoProg = 0, segParoProg = 0 //, segInactividad = 0
      for (let i = 0; i < this.horas.length; i++) {
        const H = this.horas[i]
        segParoNoProg += Number(H && (H.segundosParo ?? H.SegundosParo) || 0)
        segParoProg   += Number(H && (H.segundosParoProgramado ?? H.SegundosParoProgramado) || 0)
        // segInactividad+= Number(H && (H.segundosInactividad ?? H.SegundosInactividad) || 0)
      }
      const tmSeg = Math.max(0, segParoNoProg + segParoProg/* + segInactividad*/)


      let oeeFinal = 0
        if (this.horas && this.horas.length) {
          const last = this.horas[this.horas.length - 1]
          oeeFinal = Number(
            last?.resumen?.acumulado?.oee ??
            last?.Resumen?.Acumulado?.Oee ?? 0
          )
        }

      return { perCav, tmSeg, segParoNoProg, segParoProg, /*segInactividad,*/ oee: oeeFinal }
    },

    // ===== API tabla =====
    getCell(row, cavId, key) {
      const pc = row && row.perCav ? row.perCav[cavId] : null
      return (pc && pc[key] != null) ? pc[key] : 0
    },
    formatOee(n) {
      const v = Number(n || 0)
      const r = Math.round(v * 100) / 100
      return (r % 1 === 0) ? String(r) : r.toFixed(2)
    },

    // ===== Orquestador =====
    rebuild() {
      this.cavArticuloMap = this.buildCavArticuloMap();
      this.cavList = this.buildCavList();
      this.rows = this.buildRows();
      this.totals = this.buildTotals(this.rows);
    },

    // === Helpers de tiempo muerto (segundos) ===
    fmtSegundos(s = 0) {
      const t = Math.max(0, Number(s) || 0);
      const h = Math.floor(t / 3600);
      const m = Math.floor((t % 3600) / 60);
      const sec = t % 60;
      return [h, m, sec].map(v => String(v).padStart(2, '0')).join(':');
    },
    segMuertoHora(h) {
      if (!h) return 0;
      const sp = Number(h.segundosParo ?? h.SegundosParo ?? 0);
      const spp = Number(h.segundosParoProgramado ?? h.SegundosParoProgramado ?? 0);
      const si = Number(h.segundosInactividad ?? h.SegundosInactividad ?? 0);
      return Math.max(0, sp + spp + si);
    },
    hhmmss(total = 0) {
      const h = Math.floor(total / 3600);
      const m = Math.floor((total % 3600) / 60);
      const s = Math.floor(total % 60);
      return [h, m, s].map(v => String(v).padStart(2,'0')).join(':');
    },

    getParos(itemHora) {
      // Nombres tolerantes para tus campos
      const prog = Number(
        this.getProp(itemHora, ['segundosParoProgramado','SegundosParoProgramado','segundosProgramado','SegundosProgramado'
        // ,'segundosInactividad','SegundosInactividad'
        ])
      ) || 0;

      const noProg = Number(
        this.getProp(itemHora, ['segundosParoNoProgramado','SegundosParoNoProgramado','segundosNoProgramado','SegundosNoProgramado','segundosParo','SegundosParo'])
      ) || 0;

      return { prog, noProg, total: prog + noProg };
    },
    sumCol(col) {
      return (this.horas || []).reduce((acc, h) => acc + this.num(this.cell(h, col.cavId, col.field)), 0);
    },
    lastNonZero(col) {
      const hs = this.horas || [];
      for (let i = hs.length - 1; i >= 0; i--) {
        const v = this.num(this.cell(hs[i], col.cavId, col.field));
        if (v !== 0) return v;
      }
      return hs.length ? this.num(this.cell(hs[hs.length - 1], col.cavId, col.field)) : 0;
    },

    // obtiene el último par de acumulados (est/real) con datos
    lastAcums(col) {
      const hs = this.horas || [];
      for (let i = hs.length - 1; i >= 0; i--) {
        const est = this.num(this.cell(hs[i], col.cavId, 'estAcum'));
        const rea = this.num(this.cell(hs[i], col.cavId, 'realAcum'));
        if (est !== 0 || rea !== 0) return { est, rea };
      }
      if (!hs.length) return { est: 0, rea: 0 };
      return {
        est: this.num(this.cell(hs[hs.length - 1], col.cavId, 'estAcum')),
        rea: this.num(this.cell(hs[hs.length - 1], col.cavId, 'realAcum'))
      };
    },

    // Suma lo que ya pinta cada celda "Hora"
    sumHoras(col, fieldOverride = null) {
      const f = fieldOverride || col.field;
      return (this.horas || []).reduce(
        (acc, h) => acc + this.num(this.cell(h, col.cavId, f)),
        0
      );
    },

    // Total: replica Hora en Acumulado
    totalCell(col) {
      const f = col.field;

      // Columnas de HORA: se suman
      if (f === 'estHora' || f === 'realHora' || f === 'diffHora' || f === 'noOk') {
        return this.sumHoras(col);
      }

      // ACUMULADOS: replicar lo de HORA
      if (f === 'estAcum')  return this.sumHoras(col, 'estHora');
      if (f === 'realAcum') return this.sumHoras(col, 'realHora');
      if (f === 'diffAcum') {
        const est = this.sumHoras(col, 'estHora');
        const rea = this.sumHoras(col, 'realHora');
        return est - rea; // mismo criterio que en filas
      }

      return 0;
    },
  }
}
</script>

<style scoped>
.disabled-input {
  cursor: default !important;
}

.disabled-input>>>.vd-activator {
  pointer-events: none;
}

.disabled-input>>>label {
  pointer-events: none;
}

.force-border-bottom {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.border-bottom-white {
  border-bottom: 1px solid #dddddd;
}

.max-width-th {
  max-width: 80px;
}

.custom-background-color {
  background-color: rgb(42, 96, 153);
}

.custom-stripped-color tbody tr:nth-child(odd) {
  background-color: rgba(42, 96, 153, 0.14);
}

.background-color-estandar {
  background-color: #268db0;
}

.background-color-estandar_row {
  background-color: rgba(38, 141, 176, 0.3);
}

.background-color-real {
  background-color: #993981;
}

.background-color-real_row {
  background-color: rgba(153, 57, 129, 0.3);
}

.background-color-diferencia {
  background-color: #cc6023;
}

.background-color-diferencia_row {
  background-color: rgba(204, 97, 35, 0.4);
}

/* .counter-font-default-size {
  font-size: 0.875rem;
} */

th {
  text-align: center !important;
  font-size: 1.0625rem !important;
  color: white !important;
}

tbody tr {
  text-align: center !important;
}

table th+th {
  border-left: 1px solid #dddddd;
}

table td+td {
  border-left: 1px solid #dddddd;
}

.no-seleccionable {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
<style>
/* Tamaño base escritorio “normal” */
.hora-por-hora-table th,
.hora-por-hora-table td {
  font-size: 18px !important;
}

/* 🔁 Todo lo que está dentro de las celdas hereda el tamaño */
.hora-por-hora-table td div,
.hora-por-hora-table td span,
.hora-por-hora-table td li,
.hora-por-hora-table td strong {
  font-size: inherit !important;
}
/* 🔁 Todo lo que está dentro de las celdas hereda el tamaño */
.hora-por-hora-table td ul,
.hora-por-hora-table td div,
.hora-por-hora-table td span,
.hora-por-hora-table td li,
.hora-por-hora-table td strong {
  font-size: inherit !important;
}


/* Anulamos tamaños pequeños de Vuetify dentro de la tabla */
.hora-por-hora-table .caption,
.hora-por-hora-table .body-2,
.hora-por-hora-table small {
  font-size: inherit !important;
}

.hora-por-hora-table th,
.hora-por-hora-table td {
  font-size: 18px !important;
}

.hora-por-hora-table td.tiempo-paro-cell,
.hora-por-hora-table td.tiempo-paro-cell * {
  font-size: 1.1em !important;
  line-height: 1.2;
}

/* Pantallas grandes */
@media (min-width: 1600px) {
  .hora-por-hora-table th,
  .hora-por-hora-table td {
    font-size: 20px !important;
  }
}

@media (min-width: 1900px) {
  .hora-por-hora-table th,
  .hora-por-hora-table td {
    font-size: 22px !important;
  }
}

@media (min-width: 2300px) {
  .hora-por-hora-table th,
  .hora-por-hora-table td {
    font-size: 24px !important;
  }
  
.hora-por-hora-table td.tiempo-paro-cell,
.hora-por-hora-table td.tiempo-paro-cell * {
  font-size: 1.3em !important;
  line-height: 1.2;
}
}

/* Tablets */
@media (max-width: 1024px) {
  .hora-por-hora-table th,
  .hora-por-hora-table td {
    font-size: 16px !important;
  }
}

/* Teléfonos */
@media (max-width: 768px) {
  .hora-por-hora-table th,
  .hora-por-hora-table td {
    font-size: 14px !important;
  }
}
@media (min-width: 2800px) {
  .hora-por-hora-table th,
  .hora-por-hora-table td {
    font-size: 46px !important;
  }
  .hora-por-hora-table td.tiempo-paro-cell,
  .hora-por-hora-table td.tiempo-paro-cell * {
    font-size: 1.3em !important;
    line-height: 1.2;
  }
}
</style>